import { FileRecordDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';

export const REQUEST_FILE_UPLOAD_CANCEL = '[FileUpload][Request] Cancel Upload';
export const REQUEST_FILE_UPLOAD_START = '[FileUpload][Request] Start Upload';
export const REQUEST_FILE_UPLOAD_RETRY = '[FileUpload][Request] Retry Upload';
export const RESPONSE_FILE_UPLOAD_CANCEL = '[FileUpload][Response] Cancel Upload';
export const RESPONSE_FILE_UPLOAD_COMPLETE = '[FileUpload][Response] Upload Complete';
export const RESPONSE_FILE_UPLOAD_ERROR = '[FileUpload][Response] Upload Error';
export const RESPONSE_FILE_UPLOAD_PROGRESS = '[FileUpload][Response] Upload Progress';
export const RESPONSE_FILE_UPLOAD_START = '[FileUpload][Response] Start Upload';

export const RequestFileUploadStartAction = createAction(
  REQUEST_FILE_UPLOAD_START,
  props<{
    id: string;
    file: File;
    url?: string;
    uploadType?: string;
    modelName?: string;
    purpose?: string;
    organisationId?: string;
  }>(),
);

export const ResponseFileUploadStartedAction = createAction(
  RESPONSE_FILE_UPLOAD_START,
  props<{ id: string }>(),
);

export const RequestFileUploadCancelAction = createAction(
  REQUEST_FILE_UPLOAD_CANCEL,
  props<{ id: string }>(),
);

export const ResponseFileUploadCancelAction = createAction(
  RESPONSE_FILE_UPLOAD_CANCEL,
  props<{ id: string }>(),
);

export const ResponseFileUploadProgressAction = createAction(
  RESPONSE_FILE_UPLOAD_PROGRESS,
  props<{ id: string; progress: number }>(),
);

export const ResponseFileUploadCompleteAction = createAction(
  RESPONSE_FILE_UPLOAD_COMPLETE,
  props<{ id: string; response: FileRecordDto; uploadType?: string }>(),
);

export const ResponseFileUploadErrorAction = createAction(
  RESPONSE_FILE_UPLOAD_ERROR,
  props<{ id: string; error: any; status?: number }>(),
);

export const RequestFileUploadRetryAction = createAction(
  REQUEST_FILE_UPLOAD_RETRY,
  props<{ id: string }>(),
);
